export const IDENT_SEARCH_QUERY = "search_query"
export const IDENT_SEARCH_SELECTION = "search_selection"
export const IDENT_FILTER_DATA = "filter_data_ident"
